import React from 'react';
import { TileInfo } from 'app/home/index.functions';
import { Box } from '@mui/material';
import { formatElementDashboardName } from 'tools/tools';
import { escape } from 'lodash';

export const TileName = function ({ style, defaultStyle, tile }: { style?: any; defaultStyle?: any; tile: TileInfo }) {
    return (
        <Box
            className={'tile-element__name'}
            sx={{
                ...style,
                ...defaultStyle,
            }}
            dangerouslySetInnerHTML={{
                __html:
                    undefined !== tile.element_dashboard_name_with_formatting &&
                    tile.element_dashboard_name_with_formatting > ''
                        ? formatElementDashboardName(tile.element_dashboard_name_with_formatting)
                        : escape(tile.element_dashboard_name ?? ''),
            }}
        ></Box>
    );
};
